import { render, staticRenderFns } from "./ProductSingleProperties.vue?vue&type=template&id=8f8c1cde&"
import script from "./ProductSingleProperties.vue?vue&type=script&lang=js&"
export * from "./ProductSingleProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports